const CARD_KINDS = new Set(['payment_card', 'gift_card', 'transit_card', 'membership_card',
  'insurance_card', 'id_document', 'key_card']);

// A search the user has started (results may still be loading or have failed).
function hasQuery(search) {
  return search.status !== 'idle' && (search.q !== '' || search.kinds.length > 0);
}

// Results are in and applied to the box.
function isActive(search) {
  return search.status === 'done' && hasQuery(search);
}

// The ids the box should render, in order. Search order wins once results are
// in (not while loading or after an error); ids the search returns that are not
// in the box (soft-deleted, not yet loaded) are dropped rather than rendered as
// empty slots.
function visibleIds(allIds, filterActive, filteredStack, search) {
  const base = filterActive ? allIds.filter((id) => filteredStack[id]) : allIds;
  if (!isActive(search)) return base;
  const inBase = new Set(base);
  return search.ids.filter((id) => inBase.has(id));
}

// An applied search that leaves nothing on screen (no hits, or none survive the tag filter).
function noMatches(search, visible) {
  return isActive(search) && visible.length === 0;
}

// The user has an index to search: kind counts loaded and non-empty.
function hasIndex(kindCounts) {
  return !!kindCounts && Object.keys(kindCounts).length > 0;
}

function formatCardLabel(kind, display = {}) {
  const label = kind.replace(/_/g, ' ');
  if (!CARD_KINDS.has(kind)) return label;
  const parts = [label];
  if (display.last4) parts.push(`••${display.last4}`);
  if (display.expires) {
    const [y, m] = display.expires.split('-');
    parts.push(`exp ${m}/${y.slice(2)}`);
  }
  return parts.join(' · ');
}

export const searchUtilities = { hasQuery, isActive, visibleIds, noMatches, hasIndex, formatCardLabel };
